import { createGlobalStyle } from 'styled-components';

const colors = {
  grayBlack: '#000',
  grayWhite: '#fff',
  gray100: '#1F1F1F',
  gray50: '#535353',
  gray40: '#939393',
  gray30: '#D9D9D9',
  gray20: '#EEE',
  gray10: '#F8F8F8',
  blue70: '#4E71CA',
  blue50: '#3468ED',
  blue30: '#BAC8ED',
  blue20: '#EEF3FD',
  blue10: '#FAFBFD',
  yellow40: '#FFD464',
  yellowGreen60: '#8AAB60',
  green80: '#488C6C',
  green50: '#1FB46C',
  green20: '#E6F8EF',
  orange60: '#DC994B',
  orange50: '#FF8718',
  orange20: '#FECFA3',
  red90: '#CA9393',
  red80: '#C94545',
  red50: '#EF2D2D',
  red10: '#F0CACA',
  brand: '#9370DB',
  brandLight: '#E8E0F7',
} as const;

export default colors;

export type Colors = keyof typeof colors;

export const GlobalColorsStyle = createGlobalStyle`
  :root {
    --gray-black: ${colors.grayBlack};
    --gray-white: ${colors.grayWhite};
    --gray-100: ${colors.gray100};
    --gray-50: ${colors.gray50};
    --gray-40: ${colors.gray40};
    --gray-30: ${colors.gray30};
    --gray-20: ${colors.gray20};
    --gray-10: ${colors.gray10};
    --blue-70: ${colors.blue70};
    --blue-50: ${colors.blue50};
    --blue-30: ${colors.blue30};
    --blue-20: ${colors.blue20};
    --blue-10: ${colors.blue10};
    --yellow-40: ${colors.yellow40};
    --yellow-green-60: ${colors.yellowGreen60};
    --green-80: ${colors.green80};
    --green-50: ${colors.green50};
    --green-20: ${colors.green20};
    --orange-60: ${colors.orange60};
    --orange-50: ${colors.orange50};
    --orange-20: ${colors.orange20};
    --red-90: ${colors.red90};
    --red-80: ${colors.red80};
    --red-50: ${colors.red50};
    --red-10: ${colors.red10};
    --brand: ${colors.brand};
    --brand-light: ${colors.brandLight};
  }
`;
